module.exports = __webpack_public_path__ + "static/BT-mobile-20-a9f042505d57c6fda3e1704174a1686e.jpg";